module.exports = __webpack_public_path__ + "static/media/avatar_turtle.324ffe1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_turtle.png
// module id = 400
// module chunks = 0